import { FormFieldComponent } from '@app/modules/shared/components/form-field/form-field.component';
import { FormService } from './../../core/services/form.service';
import { FormGroup } from '@angular/forms';
import { Directive, Input, HostListener, QueryList, ViewChildren, ContentChildren, ElementRef } from '@angular/core';

@Directive({
  selector: '[iqForm]'
})
export class FormDirective {

  @ContentChildren( FormFieldComponent ) formFields: QueryList<FormFieldComponent>;

  constructor( private formService: FormService, private elementRef: ElementRef ) { }

  private _formGroup: FormGroup;
  @Input('iqForm')
  public get formGroup(): FormGroup {
    return this._formGroup;
  }

  public set formGroup(val: FormGroup ) {
      this._formGroup = val;

  }

  public showErrorMessage() {
    this.formFields.forEach( item => {
      item.updateErrorMessage();
    });
    // this.formService.markDirty( this.formGroup );


      if ( this.formGroup.invalid ) {
        const el = this.elementRef.nativeElement.querySelector( '.iq-input.ng-invalid' );
        if ( el ) {
          el.focus();
          if ( el.select ) {
            el.select();
          }
        }
      }

  }

  @HostListener('submit', ['$event'])
  onSubmit(event) {
    this.showErrorMessage();

  }
}
